import React, { Component } from "react"
import { Button, Table } from "react-bootstrap"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import AlertModal from "../../fragments/AlertModal"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { Link } from "react-router"
import moment from "moment"

export default class CommissionLogs extends Component {

  pageSize = 10

  state = {
    page: 0,
    running: false,
    success: false,
    error: null,
    allDataLoaded: false,
    data: [],
    confirmDelete: false,
  }

  componentDidMount() {
    this.loadMore()
  }

  loadMore = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { data, page } = this.state

    blockingFetchService(
      accessToken => apiServerApi.loadCommissionLogs(accessToken, page, this.pageSize),
      resp => {
        data.push(...resp)
        this.setState({
          success: true,
          data,
          allDataLoaded: resp.length < this.pageSize,
          page: resp.length === this.pageSize ? page+1 : page
        })
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  doDeleteAll = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.deleteAllCommissionLog(accessToken),
      _ => {
        this.setState({
          success: true,
          data: [],
        })
        this.closeConfirmDeleteAll()
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeConfirmDeleteAll = () => this.setState({ confirmDelete: false })

  renderTd = content => <td className='align-center v-center'>{ content }</td>

  renderItem = ({ id, loan, loanCommission, journalEntry, createdOn }) => {

    loan = loan ? loan : { bundle: {} }
    loanCommission = loanCommission ? loanCommission : {}
    journalEntry = journalEntry ? journalEntry : {}

    const { id: loanId, bundle: { name: bundleName } } = loan,

    { id: commissionId, name: commissionName } = loanCommission,

    { transactionId } = journalEntry,

    createdDate = <small className="gray">{createdOn ? moment(createdOn).format('lll') : ''}</small>,

    loanLink = !!loanId && <Link to={`/loans/${loanId}/detail`}>{ bundleName }</Link>,

    commissionLink = commissionId
     ? <Link to={`/loancommission/${commissionId}/detail`}>{ commissionName }</Link>
     : null,

    journalLink = <Link to={`/journalentries/${transactionId}/detail`}>{ transactionId }</Link>

    return <tr key={`commission-log-${id}`}>
      { this.renderTd(createdDate) }
      { this.renderTd(loanLink) }
      { this.renderTd(commissionLink) }
      { this.renderTd(journalLink) }
    </tr>
  }

  renderDeleteAllButton = disabled => (
    <div className="align-right mv-10">
      <Button onClick={() => this.setState({ confirmDelete: true })} disabled={ disabled }>
        Delete all
      </Button>
    </div>
  )

  renderNoItems = () =>
    <tr>
      <td colSpan={4} className="pv-40 align-center gray">
        No logs found!
      </td>
    </tr>

  renderContent = () => {

    const { data, confirmDelete, running } = this.state

    return <div>

      { this.renderDeleteAllButton(!data.length || running) }

      <Table striped condensed hover responsive>
        <thead>
          <tr>
            { this.renderTd('Dates') }
            { this.renderTd('Loans') }
            { this.renderTd('Activity names') }
            { this.renderTd('Journal entries') }
          </tr>
        </thead>
        <tbody>
          { data.length ? data.map(this.renderItem): this.renderNoItems() }
        </tbody>
      </Table>

      <AlertModal
        show={ confirmDelete }
        title="Confirm deletion"
        body={ <h3>Are you sure you want to delete all?</h3> }
        bsStyle="danger"
        close={ this.closeConfirmDeleteAll }
        confirm={ this.doDeleteAll }
        proceedText="Delete"
        disabled={ running }
      />
    </div>
  }

  render() {

    const { show, close } = this.props,
    { running, allDataLoaded } = this.state

    return (
      <AlertModal
        show={ show }
        title="Automatic activities log"
        body={ this.renderContent() }
        bsStyle="info"
        close={ close }
        confirm={ this.loadMore }
        proceedText="Load more"
        disabled={ running || allDataLoaded }
        bsSize="lg"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/CommissionLogs.js